import { render, staticRenderFns } from "./MaterialsManage.vue?vue&type=template&id=74f98a75&scoped=true"
import script from "./MaterialsManage.vue?vue&type=script&lang=js"
export * from "./MaterialsManage.vue?vue&type=script&lang=js"
import style0 from "./MaterialsManage.vue?vue&type=style&index=0&id=74f98a75&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f98a75",
  null
  
)

export default component.exports